import React, { useState, useRef, useEffect, useCallback } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { sttFromMic } from './voice.jsx';
import ColDropdownSpeech from './col_dropdown_speech.jsx';
import './mic_button.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { sendRequest } from './token_util.js';
import { baseUrl_api } from './url.jsx';


function MicButton({ loginInfo, isMobile, onRecordingStatusChange, onRecognizedTextChange, onSepaker, 
                  onRealTimeText, onCheckLogin, onAlertStatus, onClickSaveSpeech, onSpeechLanguage,
                  isPro=false, }) {
  const isRecording = useRef(false);
  const shiftSpeechLanguage = useRef(false); // 不改变组件颜色
  const selectedLanguageValue = useRef("zh-CN");

  const [pulse, setPulse] = useState(false);
  const [realTimeText, setRealTimeText] = useState("");
  const [recognizedText, setRecognizedText] = useState("");
  const [speaker, setSpeaker] = useState("");
  const [scale, setScale] = useState(1);
  const [timer, setTimer] = useState(null);
  const [seconds, setSeconds] = useState(-10); // 给 10 秒的预留时间  
  const secondsRef = useRef(seconds); // 使用时间
  const leftMeetingRef = useRef(0);   // 数据库中记录的剩余时间

  // 计算时长
  useEffect(() => {
    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [timer]);

  // 开始计时
  const startTimer = () => {
    if (!timer) {
      const newTimer = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds + 1);
      }, 1000);
      setTimer(newTimer);
    }
  };

  // 结束计时
  const stopTimer = () => {
    if (timer) {
      clearInterval(timer);
      setTimer(null);
    }
  };

  useEffect(() => {
    secondsRef.current = seconds;    
    
    // 剩余时间为 0 停止录音
    if (seconds > 0) {
      if( leftMeetingRef.current - seconds <= 0 ) {
        handleStopRecording();
        onAlertStatus("danger");
      } else if (leftMeetingRef.current - seconds <= 600 ) {
        onAlertStatus("warning");
      } else {
        onAlertStatus("success");
      };
    };

    // 计时满 1 分钟后发送请求到后端登记
    if (seconds >= 60) {
      sendRecordTimer();
      leftMeetingRef.current = leftMeetingRef.current - 60;
      
      setSeconds(0)
    };

    // 在组件挂载时监听 beforeunload 事件
    const wrappedHandleBeforeUnload = (event) =>
      handleStopRecording();

    window.addEventListener("beforeunload", wrappedHandleBeforeUnload);
  
    // 在组件卸载时移除 beforeunload 事件监听器
    return () => {
      window.removeEventListener("beforeunload", wrappedHandleBeforeUnload);
    };
  }, [seconds])

  const sendRecordTimer = () => {
    if (loginInfo) {
      if (Object.keys(loginInfo).length > 0) {
        const data = {
          action: "stop",        
          time: secondsRef.current < 0 ? 0: secondsRef.current ,
          uid: loginInfo['uid'],
        };
        
        if (loginInfo['uid']) {
          fetch(baseUrl_api + "/stop_timer", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
            keepalive: true,
          });
        }
      }
    }
  }

  useEffect(() => {
    // 在组件卸载时发送请求
    return () => {
      handleStopRecording();
    };
  }, []);


  useEffect(() => {
    onRecognizedTextChange(recognizedText);
    onSepaker(speaker);
  }, [recognizedText]);

  useEffect(() => {
    onRealTimeText(realTimeText);
  }, [realTimeText]);


  const startRecording = () => {
    isRecording.current = true;
    shiftSpeechLanguage.current = false;
    setPulse(true);   // 图标闪烁
    onRecordingStatusChange(true);

    startTimer();

    // sttFromMic(
    //   setRealTimeText,
    //   isRecording,
    //   shiftSpeechLanguage,
    //   setRecognizedText,
    //   setSpeaker,
    //   selectedLanguageValue.current,
    //   isPro,
    // );
  }

  useEffect(() => {
    if(isRecording.current) {
      sttFromMic(
        setRealTimeText,
        isRecording,
        shiftSpeechLanguage,
        setRecognizedText,
        setSpeaker,
        selectedLanguageValue.current,
        isPro,
      );
    };
  }, [isRecording.current, shiftSpeechLanguage.current]);

  const handleMeetingLeft =  async() =>{    
    const data = {
      uid: loginInfo.uid,
    };
    sendRequest("/meeting_left", data)
    .then(result => {
      const resultJson = JSON.parse(result);
      const parsedResponse = JSON.parse(resultJson.response);
      leftMeetingRef.current = parsedResponse.seconds; 
    })
    .catch((error) => {
      console.error("Error fetching qrCodeUrl:", error);
    });
  }

  const handleStartRecording = useCallback( () => {    
    if (!loginInfo.islogin){
      onCheckLogin();
    } else {
      // 登录后获取用户剩余时间
      handleMeetingLeft()
      startRecording();
    }
  }, [onRecordingStatusChange, loginInfo]);  
  
  // 停止录音
  const handleStopRecording = useCallback(() => {
    isRecording.current = false;
    shiftSpeechLanguage.current = false;

    setPulse(false);
    stopTimer();
    onRecordingStatusChange(false);
  }, [onRecordingStatusChange]);

  // 切换语言
  const handleShiftLanguage = useCallback(() => {
    shiftSpeechLanguage.current = true;    
    console.log('shift language', shiftSpeechLanguage);

    setPulse(false);
    stopTimer();
    onRecordingStatusChange(false);
  }, [onRecordingStatusChange]);

  const handleSelectSpeech = (language, value) => {
    // 在这里处理选择的值，例如将其传递给其他组件或执行其他操作
    selectedLanguageValue.current = value; // 更新 selectedValue
    onSpeechLanguage(language);   // 调用父组件回调函数获取 speech 的语种
    
    // 如果正在录音，停止并重新启动录音
    if (isRecording.current) {
      handleShiftLanguage();
      
      setTimeout(() => {
        startRecording();
      }, 2000);
    }
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === ' ') {
        event.preventDefault();
        if (!isRecording.current) {
          handleStartRecording();
        } else {
          handleStopRecording();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleStartRecording, handleStopRecording]);


  return (
    <Col>
      <Row className="align-items-center">
        <Col className="align-items-center" style={{ display: "flex" }}>
          <Button
            variant={isRecording.current ? "warning" :"success"}
            onClick={isRecording.current ? handleStopRecording : handleStartRecording}
            className={`me-2 round-button ${pulse ? 'pulse' : ''}`}
          >
            <i className={`bi ${isRecording.current ? 'bi-mic-mute' : 'bi-mic'} icon-1-5x`} style={{ transform: `scale(${scale})` }}></i>
          </Button>

          <ColDropdownSpeech
            className="me-2"
            isMobile={isMobile}
            onSelect={handleSelectSpeech}
            onClick={onClickSaveSpeech}
            isRecording={isRecording.current}
          />
        </Col>
      </Row>
    </Col>
  );
}

export default MicButton;